import { Boundaries } from "@planzone/core";
import { Gantt } from "@planzone/dto";
import { events } from "@planzone/events";
import { propagateEvent } from "./propagateEvent";

function handleConstrainElements(
  gantt: Gantt,
  data: Boundaries["constrainElements"]["success"],
): Gantt {
  return {
    ...gantt,
    projects: propagateEvent(gantt, {
      type: events.constrainElementsSucceeded,
      data,
    }).projects,
    constraints: [...gantt.constraints, data.constraint],
  };
}

export { handleConstrainElements };
